var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHandGrabbing = function SvgIconHandGrabbing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.092 6.592A2.875 2.875 0 0 1 12 6.446a2.875 2.875 0 0 1 4.51 1.029 2.874 2.874 0 0 1 3.99 2.65v4.125a8.5 8.5 0 1 1-17 0v-1.505a2.884 2.884 0 0 1 2.87-2.87h.88v-1.25c0-.763.303-1.494.842-2.033m1.158 7.283a1 1 0 1 1-2 0v-2h-.872a.884.884 0 0 0-.878.878v1.497a6.5 6.5 0 0 0 13 0v-4.125a.875.875 0 0 0-1.75 0v1.5a1 1 0 1 1-2 0v-3a.875.875 0 0 0-1.75 0v3a1 1 0 1 1-2 0v-3a.875.875 0 0 0-1.75 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHandGrabbing;